import compliancePng from '../../assets/shield-compliance.png'
import classes from './index.module.scss'

export default function CompliancePill({ percentage, nominator, denominator, margin }) {
  return (
    <span className={`${classes.pill} ${nominator === denominator && classes.compliant}`} style={{ margin: margin || '0 0 0 1rem' }}>
      <img src={compliancePng} alt='Icon for criteria required to be compliant' height={20} width={20} />
      <p>
        {percentage}% compliant ({nominator}/{denominator})
      </p>
    </span>
  )
}
